export const environment = {
  production: false,
  enableServiceWorker: false
};
